export default __webpack_public_path__ + "media/06e0a58cf99c43563e64ab7cfd4ac3d204c25dcb38d11ef66800160927ff971c.svg";